import React, {Component} from "react";
import config from 'react-global-configuration';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import BrandEMIAdmin from "./BrandEMIAdmin";


class APIConfiguration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emiMenus: []
        };
    }

        render()
        {

            return (
                <h4> To be designed</h4>
            );

        }

}

export default APIConfiguration;